import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { getExtensionSafe } from "../utils";
import { DocsComponentName } from "../constant";
import { SafeEntry } from '@tencent/docs-service-interface';
var getSafeFolderComponent = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(options) {
    var mobileMode, docsComponentName;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          mobileMode = options.mobileMode;
          docsComponentName = mobileMode ? DocsComponentName.SAFE_FOLDER_MOBILE : DocsComponentName.SAFE_FOLDER;
          _context.next = 4;
          return getExtensionSafe(docsComponentName);
        case 4:
          return _context.abrupt("return", _context.sent);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getSafeFolderComponent(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var enableSafeFolder = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(options) {
    var extension;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return getSafeFolderComponent(options);
        case 2:
          extension = _context2.sent;
          extension.show(_objectSpread(_objectSpread({}, options), {}, {
            safeEntry: SafeEntry.ENABLE_SAFE_FOLDER
          }));
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function enableSafeFolder(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var changeSafeFolderPassword = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(options) {
    var extension;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return getSafeFolderComponent(options);
        case 2:
          extension = _context3.sent;
          extension.show(_objectSpread(_objectSpread({}, options), {}, {
            safeEntry: SafeEntry.CHANGE_PASSWORD
          }));
        case 4:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function changeSafeFolderPassword(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
export var retrieveSafeFolderPassword = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(options) {
    var extension;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return getSafeFolderComponent(options);
        case 2:
          extension = _context4.sent;
          extension.show(_objectSpread(_objectSpread({}, options), {}, {
            safeEntry: SafeEntry.RETRIEVE_PASSWORD
          }));
        case 4:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function retrieveSafeFolderPassword(_x4) {
    return _ref4.apply(this, arguments);
  };
}();
export var unlockSafeFolder = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(options) {
    var extension;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return getSafeFolderComponent(options);
        case 2:
          extension = _context5.sent;
          extension.show(_objectSpread(_objectSpread({}, options), {}, {
            safeEntry: SafeEntry.UNLOCK
          }));
        case 4:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function unlockSafeFolder(_x5) {
    return _ref5.apply(this, arguments);
  };
}();